<span class="sort-toggle" (click)="onToggleClick()">
    {{label | translate}}
    <mat-icon fontSet="fa" 
        [fontIcon]="(sortParam.sortDirection === 'ASC') ? 'fa-sort-down':'fa-sort-up'" 
        class="material-icons">
    </mat-icon>
</span>
